import { defineStore } from "pinia";

import { version as currentVersion } from "../../../package.json";
import { checkVersion } from "@/App/version/version.service";

type VersionStoreState = {
  remoteVersion: string;
};

export const useVersionStore = defineStore({
  id: "version",
  state: (): VersionStoreState => ({
    remoteVersion: currentVersion,
  }),
  actions: {
    async checkForLatestVersion(): Promise<void> {
      if (currentVersion === this.remoteVersion) {
        try {
          this.remoteVersion = await checkVersion();
        } catch (ignored) {
          console.log("Failed to get latest version of dashboard", ignored);
        }
      }
    },
  },
  getters: {
    isLatest: (state: VersionStoreState) => currentVersion === state.remoteVersion,
  },
});
